/**
 * DiscoveryCollabs 스타일
 * @description 시안 `3041:2412`. 머리줄과 카드줄 사이 12.
 *
 *   카드 폭은 줄 폭(`cqw`)에서 계산한다. 폰에서는 앱과 같은 식이다 — 왼쪽 여백 + (카드 셋 +
 *   간격 셋) + 네 번째의 옆구리(24) = 줄 폭. 시안의 124 는 420 짜리 화면에서 그 계산의
 *   결과값이라, 못 박으면 좁은 기기에서 세 장이 안 들어간다. 네 번째를 조금 남기는 것은
 *   **더 있다는 신호**다.
 *
 *   넓은 화면은 옆구리 없이 딱 맞게 늘어놓는다 — 태블릿 4장, 데스크톱 6장. 시안(190)에서
 *   카드가 멀어지지 않는 수다.
 */
export const discoveryCollabsStyles = {
  root: "flex w-full flex-col gap-[var(--fw-space-gap-md)]",
  card: [
    "w-[calc((100cqw_-_var(--fw-inset-tab)_-_var(--fw-space-gap-sm)*3_-_24px)/3)]",
    "tablet:w-[calc((100cqw_-_var(--fw-inset-tab)*2_-_var(--fw-space-gap-sm)*3)/4)]",
    "desktop:w-[calc((100cqw_-_var(--fw-inset-tab)*2_-_var(--fw-space-gap-sm)*5)/6)]",
  ].join(" "),
};

/** 이미지를 내려받을 폭 힌트 — 카드가 가장 넓게 서는 데스크톱 6열 기준(약 200) */
export const DISCOVERY_COLLAB_IMAGE_SIZES =
  "(min-width: 1280px) 200px, (min-width: 768px) 25vw, 30vw";
